export class ImportUsers {
  public brandId: number;
  public fileId: string;
}
